module.exports = __webpack_public_path__ + "img/happy.863d1fc3.svg";